import { iconFileUpload } from "assets/icons"
import { Button } from "components/Button"
import { InputHTMLAttributes, useRef } from "react"
import { ErrorText, ImageInput, ImageInputWrapper, TypeImage } from "./styles"

export interface InputImageProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean,
  errorMessage?: string,
  acceptImages?: string[],
  errorByTypeImage?: boolean;
  errorMessageByTypeImage?: string;
  
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const InputImage: React.FC<InputImageProps> = ({
  error,
  errorMessage,
  errorByTypeImage = false,
  errorMessageByTypeImage,
  ...props
}) => {
  const fileInput = useRef<any>(null);

  const onButtonClickHandler = () => {
    fileInput.current.click();
  }

  return (
    <ImageInputWrapper>
      <ImageInput
        type="file"
        accept="image/png"
        ref={fileInput}
        {...props}
      />
      <Button
        label="Alterar logo"
        typeBtn="blue"
        size="small"
        type="button"
        icon={iconFileUpload}
        onClick={onButtonClickHandler}
      />
      
      <TypeImage highlight={errorByTypeImage}>{errorMessageByTypeImage}</TypeImage>
      {error ? <ErrorText>{errorMessage}</ErrorText> : ""}
    </ImageInputWrapper>
  )
}